module.exports = __webpack_public_path__ + "static/media/putri_logo_big.2ba6f9be.png";